module.exports = __webpack_public_path__ + "img/kt-df.2fa02a45.png";